import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'p-brand',
  templateUrl: './p-brand.component.html',
  styleUrls: ['./p-brand.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PBrandComponent {}
